.root {
	/* CSS Modules theming placeholders */
}
